var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qr-code',{attrs:{"text":_vm.value,"size":_vm.size,"error-level":"L"}})
}
var staticRenderFns = []

export { render, staticRenderFns }